/** The YouTube library client, and the account chip's view of it. */

import { createSignal } from 'solid-js';
import type { Credentials } from '../config/defaults.ts';
import { loadCreds } from '../config/storage.ts';
import { YouTubeLibrary } from '../data/youtube-library.ts';

export interface Account {
  signedIn: boolean;
  configured: boolean;
  name: string | null;
}

const [creds, setCredsSignal] = createSignal<Credentials>(loadCreds());

export { creds };

export const lib = new YouTubeLibrary(creds());

export const [account, setAccount] = createSignal<Account>({
  signedIn: false,
  configured: lib.configured,
  name: null,
});

/** Re-reads the account state from the library after a sign-in or sign-out. */
export function refreshAccount(): void {
  setAccount({
    signedIn: lib.signedIn,
    configured: lib.configured,
    name: lib.profile?.name ?? null,
  });
}

export function reloadCreds(): Credentials {
  const next = loadCreds();
  setCredsSignal(next);
  lib.setCreds(next);
  refreshAccount();
  return next;
}

/** True when search can reach YouTube rather than only the demo crate. */
export const canSearchRemote = (): boolean => lib.signedIn || !!creds().YOUTUBE_API_KEY;
